import { CardSkeleton } from "./styles";

export function Skeleton() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <CardSkeleton style={{ height: "3rem" }} />
      <CardSkeleton style={{ height: "5rem" }} />
      <CardSkeleton style={{ height: "10rem" }} />
      <CardSkeleton style={{ height: "5rem" }} />
      <CardSkeleton style={{ height: "5rem" }} />
      <CardSkeleton style={{ height: "10rem" }} />
    </div>
  );
}
